(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hear-landing"]) return;
  try {
    
(() => {
  function prepareForm() {
    const field = document.getElementById('hear-source');
    const params = new URLSearchParams(window.location.search);
    if (field) field.value = (params.get('src') || params.get('utm_source') || 'web').slice(0, 100);
    const message = document.querySelector('.hear-form-success, .hear-form-errors');
    if (message) { message.scrollIntoView({block:'center'}); message.setAttribute('tabindex','-1'); message.focus(); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareForm, {once:true});
  else prepareForm();
  document.addEventListener('shopify:section:load', prepareForm);
})();


  } catch(e) { console.error(e); }
})();
})();
